// ── Shared import-picker text helpers (C1450) ──
//
// capToColumn() was originally private to gmail-thread-picker.js (C1449). Extracted here
// so the Jira issue picker doesn't have to import a Gmail-named module to reuse it — the
// byte cap itself has nothing to do with either provider, only with tasks.description
// being a fixed-size DB column. gmail-thread-picker.js re-exports it from here so its
// existing import (and gmail-thread-picker.test.js's import of it) keeps working unchanged.

// tasks.description is a MySQL TEXT column — 65,535 BYTES (api/src/migrations/001_schema.js).
// A long import (a multi-message email thread, a large Jira description) can exceed that;
// an uncapped write would either silently truncate server-side or 400 on the finalize
// PATCH with the reserved task_key still booked.
const MAX_DESCRIPTION_BYTES = 60000;

// capToColumn(text, noticeText?) -> string
// Byte-safe truncation to MAX_DESCRIPTION_BYTES, appending a truncation notice. Measured
// with TextEncoder, not .length — a char-count cap would let a multi-byte-heavy body
// (non-Latin text, emoji) slip past the actual byte limit MySQL enforces.
export function capToColumn(text, noticeText) {
  const str = String(text || '');
  const notice = noticeText || '\n\n_…truncated at 60 KB._';
  const encoder = new TextEncoder();
  const bytes = encoder.encode(str);
  if (bytes.length <= MAX_DESCRIPTION_BYTES) return str;

  const noticeBytes = encoder.encode(notice).length;
  const budget = Math.max(0, MAX_DESCRIPTION_BYTES - noticeBytes);
  const decoder = new TextDecoder('utf-8', { fatal: false });
  // A slice that lands mid-codepoint decodes with a trailing U+FFFD (non-fatal mode,
  // non-streaming) — strip it so the cut lands on a whole character rather than a
  // replacement glyph.
  const truncated = decoder.decode(bytes.slice(0, budget)).replace(/�$/, '');
  return truncated + notice;
}
